import { addYears, startOfYear } from "./_date-fns";
import type { Time } from "./time";

export function startOfNextYear(time: Time): Date {
	return startOfYear(addYears(time, 1));
}
